var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIdcardFront(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 110 66.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#585857;}.cls-2{fill:#de996f;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M102.3,0H7.7C3.5,0,0,3.5,0,7.7V58.4c0,4.3,3.5,7.7,7.7,7.7H102.3c4.3,0,7.7-3.5,7.7-7.7V7.7c0-4.2-3.5-7.7-7.7-7.7Zm2.4,13.9h2.8v.9H2.5v-3h2.3c.7,0,1.3-.6,1.3-1.3s-.5-1.2-1.2-1.2H2.5v-.8H107.5v2.9h-2.8c-.7,0-1.3,.6-1.3,1.3s.6,1.2,1.3,1.2ZM7.7,2.5H102.3c2.3,0,4.2,1.5,4.9,3.5H2.8c.7-2,2.6-3.5,4.9-3.5ZM102.3,63.7H7.7c-1.1,0-2.1-.3-2.9-.9H13.3c.7,0,1.3-.6,1.3-1.3s-.6-1.3-1.3-1.3H2.8c-.1-.4-.3-.8-.3-1.3h3.3c.7,0,1.3-.6,1.3-1.3s-.6-1.3-1.3-1.3H2.5V17.3H107.5V58.4c0,2.9-2.3,5.3-5.2,5.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M103.7,19.3h-30.5c-.7,0-1.3,.6-1.3,1.3V59.8c0,.7,.6,1.3,1.3,1.3h30.5c.7,0,1.3-.6,1.3-1.3V20.6c-.1-.7-.6-1.3-1.3-1.3Zm-24.4,16.3c0-1.1,.2-2.2,.6-3.2,3.1,1.7,8.7,4,17.8,4.2v4.8c0,4.7-3.6,8.7-8.2,9.1v-7.1c0-.7-.6-1.3-1.3-1.3h-.3l.4-2.5h2.9c.7,0,1.3-.6,1.3-1.3s-.7-1.3-1.4-1.3h-4c-.6,0-1.1,.5-1.2,1.1l-.8,5c-.1,.4,.1,.7,.3,1,.2,.3,.6,.4,1,.4h.5v5.7c-4.3-.8-7.6-4.5-7.6-9,0,.1,0-5.6,0-5.6Zm1.7-5.5c1.7-2.3,4.4-3.8,7.4-3.8,4.5,0,8.3,3.3,9,7.6-8.4-.1-13.6-2.2-16.4-3.8Zm.2,20.4c2,1.6,4.5,2.5,7.2,2.5s5.2-.9,7.2-2.5c1.6,2.2,2.5,5,2.6,8h-19.6c.1-3,1-5.8,2.6-8Zm21.2,8h-1.7c-.1-3.7-1.2-7.1-3.3-9.8,1.7-2,2.7-4.6,2.7-7.4v-5.7c0-6.4-5.2-11.7-11.7-11.7s-11.7,5.2-11.7,11.7v5.7c0,2.8,1,5.4,2.7,7.4-2,2.7-3.2,6.1-3.3,9.8h-1.7V21.8h28V58.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M63.2,27.6H10c-.7,0-1.3,.6-1.3,1.3s.6,1.3,1.3,1.3H63.2c.7,0,1.3-.6,1.3-1.3-.1-.7-.6-1.3-1.3-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M63.2,38.6H10c-.7,0-1.3,.6-1.3,1.3s.6,1.3,1.3,1.3H63.2c.7,0,1.3-.6,1.3-1.3-.1-.8-.6-1.3-1.3-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M63.2,49.5H10c-.7,0-1.3,.6-1.3,1.3s.6,1.2,1.3,1.2H63.2c.7,0,1.3-.6,1.3-1.3s-.6-1.2-1.3-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10,26.6h9.3c.7,0,1.3-.6,1.3-1.3s-.6-1.3-1.3-1.3H10c-.7,0-1.3,.6-1.3,1.3,0,.8,.6,1.3,1.3,1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10,37.5h9.3c.7,0,1.3-.6,1.3-1.3s-.6-1.2-1.3-1.2H10c-.7,0-1.3,.6-1.3,1.3s.6,1.2,1.3,1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10,48.5h9.3c.7,0,1.3-.6,1.3-1.3s-.6-1.3-1.3-1.3H10c-.7,0-1.3,.6-1.3,1.3s.6,1.3,1.3,1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.1,60.3c-.3,0-.7,.1-.9,.4-.2,.2-.4,.6-.4,.9s.1,.7,.4,.9c.2,.2,.6,.4,.9,.4s.7-.1,.9-.4c.2-.2,.4-.6,.4-.9s-.1-.7-.4-.9c-.2-.3-.6-.4-.9-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M83.4,39.6c.7,0,1.3-.6,1.3-1.3s-.6-1.3-1.3-1.3h-1.4c-.7,0-1.3,.6-1.3,1.3s.6,1.3,1.3,1.3h1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M101.2,11.4c-.3,0-.7,.1-.9,.4-.2,.2-.4,.6-.4,.9s.1,.7,.4,.9c.2,.2,.6,.4,.9,.4s.7-.1,.9-.4c.2-.2,.4-.6,.4-.9s-.1-.7-.4-.9c-.2-.2-.6-.4-.9-.4Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdcardFront);
export default __webpack_public_path__ + "static/media/idcard-front.9b0c6f72a427db336d682f4f1b405abc.svg";
export { ForwardRef as ReactComponent };